import ServerErrorPage from './ServerErrorPage';
export default ServerErrorPage;
export { default as ServerErrorPage } from './ServerErrorPage';
